module.exports = __webpack_public_path__ + "static/media/icon-dashboard-profile-completion.9de090a1.svg";